import * as React from "react"
import { Grid } from "../ecosystem";
import { CircleButtonCard, CardLinkList, PageHeading } from "../ecosystem/mybswh";
import { withRouter } from 'react-router-dom';
import { logUI } from "../../api/andyliticsApi";
import { XS_MOBILE, SM_MOBILE, MD_TABLET } from "../../constants/textConstants";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { connect } from "react-redux";

const Covid19CareLanding = (props) => {

    const { epicEHRDown, hasMyChart, isMyChartInActive, screenBreakPoint } = props;

    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;
    const onClickCovid19CareButton = (tileName) => {
        logUI(`MBHWeb.UI.Covid19CareLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
    }; 
    return (
        <Grid className="body-content covid-care-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading heading="COVID-19 Care" />
                    <div className="row">
                        <div className="col-12 col-xl-6 mybswh-card-container">
                           {/* <CircleButtonCard
                                cardIcon={{ name: 'vaccine' }}
                                titleStyle={{ bold: true, type: "heading-02" }}
                                disabled={!hasMyChart || isMyChartInActive || epicEHRDown}
                                to={"/vaccineeligibility"}
                                onClick={() => { onClickCovid19CareButton("COVID19") }}
                                title="Schedule Vaccine"
                                body="See if you or a family member are eligible for a dose or booster."
                            />*/}
                            <CardLinkList
                                cardIcon={{ name: 'covid-19-vaccine' }}
                                title="Schedule a Vaccine"
                                body="See if you or your family members are eligible for a vaccine."
                                list={[
                                    {
                                        text: "Clinic Visit",
                                        to: "/vaccineeligibility",
                                        onClick: () => { onClickCovid19CareButton("ClinicVisit") },
                                        disabled: (!hasMyChart || isMyChartInActive || epicEHRDown)
                                    },

                                    {
                                        text: "In-Home Vaccines",
                                        to: "/inhomevaccine",
                                        onClick: () => { onClickCovid19CareButton("InHome") },

                                    },
                                ].filter(Boolean)}
                            />
                        </div>
                        {/*<div className="col-12 col-xl-4 mybswh-card-container">
                            <CircleButtonCard
                                cardIcon={{ name: 'testing' }}
                                titleStyle={{ bold: true, type: "heading-02" }}
                                to={"/covid19screener"}
                                onClick={() => { onClickCovid19CareButton("COVID19Screener"); }}
                                title="Should I Get Tested?"
                                body="Use our free self-checker to help you decide."
                            />
                        </div>*/}
                        <div className="col-12 col-xl-6 mybswh-card-container">
                            <CircleButtonCard
                                cardIcon={{ name: 'insurance', set: 'brand' }}
                                titleStyle={!isMobile ? { type: 'heading-04', bold: false } : {}}
                                disabled={!hasMyChart || isMyChartInActive || epicEHRDown}
                                to={"/familyselection/vaccinecredentials"}
                                onClick={() => { onClickCovid19CareButton("VaccineCredentials"); }}
                                title="Vaccine Credentials"
                                body="View or share your COVID-19 vaccination status."
                                arrowIcon={{ colorStyle: 'float'}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Grid>


    )

}

const mapStateToProps = (state) => {
    return {
        hasMyChart: state.domain.hm,
        isMyChartInActive: state.dashboard.isMyChartInActive,
        epicEHRDown: state.common.epicEHRDown,
        currentUser: d.hydrateProxyUser(state.domain.cu),        
        screenBreakPoint: state.common.screenBreakPoint
    };
};

export default withRouter(connect(mapStateToProps, null)(Covid19CareLanding));